// Drop-in replacement for vue2-storage, byte-compatible with its localStorage
// format (`JSON.stringify({ value, ttl: Date.now() + ttl })` under a prefix),
// so existing stored sessions keep working.
const DEFAULTS = {
    prefix: 'app_',
    ttl: 60 * 60 * 24 * 1000,
}

export class Storage {
    constructor(options = {}) {
        this.options = { ...DEFAULTS, ...options }
    }

    key(name) {
        return `${this.options.prefix}${name}`
    }

    set(name, value, options = {}) {
        const ttl = 'ttl' in options ? options.ttl : this.options.ttl
        localStorage.setItem(this.key(name), JSON.stringify({
            value,
            ttl: Date.now() + ttl,
        }))
        return value
    }

    get(name, fallback = null) {
        const raw = localStorage.getItem(this.key(name))
        if (raw === null) return fallback
        try {
            const data = JSON.parse(raw)
            if ('ttl' in data && Number(data.ttl) < Date.now()) {
                this.remove(name)
                return fallback
            }
            return 'value' in data ? data.value : fallback
        } catch (e) {
            return fallback
        }
    }

    has(name) {
        return this.get(name, undefined) !== undefined
    }

    remove(name) {
        localStorage.removeItem(this.key(name))
    }

    clear() {
        Object.keys(localStorage)
            .filter((key) => key.startsWith(this.options.prefix))
            .forEach((key) => localStorage.removeItem(key))
    }
}

// App-independent singleton — safe to use before the Vue app is mounted
// (axios interceptors, router middleware, helpers). The plugin exposes the
// same instance as $storage for templates/Options-API code.
export const storage = new Storage({
    prefix: 'live_caller__',
    ttl: 30 * 60 * 60 * 24 * 1000,
})

export default {
    install(app) {
        app.config.globalProperties.$storage = storage
    },
}
